export default __webpack_public_path__ + "static/media/red.4fad5757.svg";